define('bindingHandlers/btnGroupSelector',[
    'jquery',
    'lib/knockout'
], function ($, ko) {
    'use strict';

    ko.bindingHandlers.btnGroupSelector = {
        update: function (element, valueAccessor) {
            var $element = $(element),
                comparisonValue = ko.unwrap(valueAccessor());

            $element.children(".btn").removeClass("active");
            $element.children("[value='" + comparisonValue + "']").addClass("active");
        }
    };
});

